<script>
    export default {
        name: "TypographyWrapper",
    };
</script>

<template>
    <div class="typography-wrapper">
        <slot></slot>
    </div>
</template>

<style lang="scss">
    .typography-wrapper {
        padding-top: 24px;
        @include bp($bp-desktop-sm) {
            padding-top: 56px;
        }

        h2 {
            margin-bottom: 16px;
            font-family: var(--typography-heading-font);
            font-size: 26px;
            font-weight: var(--typography-heading-weight);
            line-height: 40px;
            text-transform: var(--typography-heading-case);
            @include bp($bp-desktop-sm) {
                margin-bottom: 32px;
                font-size: 36px;
                line-height: 40px;
            }
        }

        h3 {
            margin-bottom: 12px;
            font-family: var(--typography-heading-font);
            font-size: 18px;
            font-weight: var(--typography-heading-weight);
            line-height: 24px;
            text-transform: var(--typography-heading-case);
            @include bp($bp-desktop-sm) {
                margin-bottom: 16px;
                font-size: 26px;
                line-height: 32px;
            }
        }

        h4 {
            margin-bottom: 6px;
            font-family: var(--typography-heading-font);
            font-size: 16px;
            font-weight: var(--typography-heading-weight);
            line-height: 20px;
            text-transform: var(--typography-heading-case);
            @include bp($bp-desktop-sm) {
                margin-bottom: 12px;
                font-size: 20px;
                line-height: 28px;
            }
        }

        p,
        li {
            color: var(--typography-text-color);
            font-size: var(--typography-text-size);
            font-weight: var(--typography-text-weight);
            line-height: var(--typography-text-height);
            a {
                color: var(--info-text--dark);
            }
        }

        p {
            &:not(:last-child) {
                margin-bottom: var(--typography-text-offset-bottom);
            }
        }

        ul,
        ol {
            margin-bottom: 20px;
            padding-left: 20px;
            li {
                margin-bottom: 4px;
                @include bp($bp-desktop-sm) {
                    margin-bottom: 8px;
                }
            }
        }

        ol {
            list-style: decimal;
            ol {
                margin-bottom: 0;
            }
        }
    }
</style>
